import React from 'react'
import moment from 'moment'
import { parseInt, range } from 'lodash'
import {
  FormCell, CellHeader, CellBody, Select, CellFooter, Label, Icon, Input, CityPicker
} from 'react-weui'
import {time2str} from "../../../../lib/Tools"


const secondsArray = range(0, 60, 5).map((second, i) => ({name: second < 10 ? `0${second}` : second, code: `11010${i}`}))
const hoursArray = range(0, 24).map((hour, i) => ({name: hour < 10 ? `0${hour}` : hour, code: `11010${i}`, sub: secondsArray}))

export default class DatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      /* firstDates: [
        { name: `今天`, code: "1", sub: hoursArray.slice(parseInt(moment().get('hour')) + 1, hoursArray.length) },
        { name: `明天`, code: "2", sub: hoursArray },
        { name: `后天`, code: "3", sub: hoursArray },
      ].slice(props.margin || 0, props.days), */
      restDates: range(0, props.days).map((_x, i) => ({
        name: moment().add(i, "days").locale("zh_cn").format("MM月DD日"), 
        code: `11010${i}`, 
        sub: i == 0 ? hoursArray.slice(parseInt(moment().get('hour')) + 1, hoursArray.length) : hoursArray
      })),
    }
  }
  
  render() {
    const { warn, onChange, days, margin } = this.props

    const dates = [/* ...this.state.firstDates, */ ...this.state.restDates]
    return (
      <React.Fragment>
        <FormCell select selectPos="after" warn={warn}>
          <CellHeader>
            <Label>日期</Label>
          </CellHeader>
          <CellBody>
            <Input type="text"
              value={this.props.picker_value.split(' ')
                .reduce((str, part, i) => str + (i === 2 ? ':' : ' ') + part)}
              onClick={ e => {
                e.preventDefault();
                this.props.showChange(true)
              }}
              placeholder="Choose Date"
              readOnly
            />
          </CellBody>
          <CellFooter>
            <Icon value="warn" />
          </CellFooter>
        </FormCell>

        <CityPicker
          data={dates}
          onCancel={() => this.props.showChange(false)}
          onChange={text => {
            this.props.showChange(false)
            onChange(time2str(moment(text, 'MM月DD日 HH mm')), text)
          }}
          show={this.props.picker_show}
        />
      </React.Fragment>
    )
  }
}

/**
 * 
 *  <Select
              data={[
                ...(
                  !valueIndex && valueIndex != "0"
                    ? [{ selected: !isNumber(valueIndex), value:  -666, label: "选择用车日期" }]
                    : []
                ),
                ...dates.map((x, i) => ({ selected: i == valueIndex, value: i, label: x }))
              ]}
              onChange={evt => onChange({ index: evt.target.value, string: dates[evt.target.value] })}
            />/ */



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/datePicker.jsx